import { CareServiceConfig } from '@app/icare/entities/careService/config'
import { patientCareServiceQueries } from '@app/icare/entities/careService/queries/patientCareServiceQueries'
import { PatientCareServiceEditDrawer } from '@app/icare/entities/patient/edits/PatientCareServiceEditDrawer'
import {
  patientFindingsQueryOptions,
  selectByGroupAndGroupByRelationId,
} from '@app/icare/entities/patient/queries/patientFindingsQueryOptions'
import type { PatientCareServiceRelation } from '@app/icare/entities/patient/schema/PatientCareService'
import { PatientId } from '@app/icare/entities/patient/schema/PatientId'
import { RelationOverview } from '@app/icare/routes/_app/patienten/$id/_edit/-components/RelationOverview'
import { isActivePatientRelation } from '@app/icare/shared/api'
import { entityParams } from '@pkg/db/utils'
import { useQuery, useSuspenseQuery } from '@tanstack/react-query'
import { createFileRoute } from '@tanstack/react-router'
import { useRelationCommitNavigation } from '../-components/useRelationCommitNavigation'

export const Route = createFileRoute('/_app/patienten/$id/_edit/_careService/pflegedienste/')({
  params: entityParams({ id: PatientId }),
  loader: ({ params, context: { queryClient } }) =>
    queryClient.ensureQueryData(patientCareServiceQueries.forIndex(params.id)),
  component: RouteComponent,
})

function RouteComponent() {
  const { id } = Route.useParams()
  const navigate = Route.useNavigate()
  const { data: careServices = [] } = useSuspenseQuery(patientCareServiceQueries.forIndex(id))
  const { data: findings = {} } = useQuery({
    ...patientFindingsQueryOptions(id),
    select: selectByGroupAndGroupByRelationId('careServices'),
  })

  const handleAfterCommit = useRelationCommitNavigation<PatientCareServiceRelation>({
    isInactive: relation => !isActivePatientRelation(relation),
    onCreateNavigate: relation =>
      navigate({
        to: '/patienten/$id/pflegedienste/$relation',
        params: { id, relation: relation.id },
      }),
    onInactiveEditNavigate: () => navigate({ to: '.', replace: true }),
  })
  return (
    <RelationOverview
      items={careServices}
      labels={CareServiceConfig}
      findings={findings}
      basePath={`/patienten/${id}/pflegedienste`}
      onEdit={params =>
        void PatientCareServiceEditDrawer.show({ patientId: id, onAfterCommit: handleAfterCommit, ...params })
      }
    />
  )
}
